
    <app-member-create-membership [isUpdateForm]="true" [isNewForm]="false" [membershipDetail]="[membership]" [member]="member" (membershipUpdated)="updateMemberships()" (closeEditDialog)="closeEditModal()"></app-member-create-membership>
